import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import EntityDIDMapping from "../../interfaces/entityDidMapping";

interface EntityDIDMappingState {
    entityDIDMapping: EntityDIDMapping[];
};

const initialState: EntityDIDMappingState = {
    entityDIDMapping: []
};

export const entityDIDMappingSlice = createSlice({
    name: 'entityDIDMapping',
    initialState,
    reducers: {
        loadEntityDIDMapping: (state, action: PayloadAction<EntityDIDMapping[]>) => {
            state.entityDIDMapping = action.payload;
        },
    },
});

export const { loadEntityDIDMapping } = entityDIDMappingSlice.actions;

export default entityDIDMappingSlice.reducer;